export default {
    install(Vue) {
        ;(function () {
            const w = window
            if (w.ChannelIO) {
                return (console.error || console.log || function () {})('ChannelIO script included twice.')
            }
            const ch = function () {
                ch.c(arguments)
            }
            ch.q = []
            ch.c = function (args) {
                ch.q.push(args)
            }
            w.ChannelIO = ch

            function l() {
                if (w.ChannelIOInitialized) {
                    return
                }
                w.ChannelIOInitialized = true
                const s = document.createElement('script')
                s.type = 'text/javascript'
                s.async = true
                s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
                s.charset = 'UTF-8'
                const x = document.getElementsByTagName('script')[0]
                x.parentNode.insertBefore(s, x)
            }

            if (document.readyState === 'complete') {
                l()
            } else if (window.attachEvent) {
                window.attachEvent('onload', l)
            } else {
                window.addEventListener('DOMContentLoaded', l, false)
                window.addEventListener('load', l, false)
            }
        })()

        const ChannelBoot = () => {
            window.ChannelIO('boot', {
                pluginKey: process.env.VUE_APP_CHANNELTALK_KEY, // .env에 정의해둔 경우
                mobileMessengerMode: 'iframe',

                //   customLauncherSelector: '.channel-talk-btn',

                appearance: {
                    position: 'br', // 기본값: bottom right
                    bottom: 100, // px 단위로 위로 올림 (기본 20)
                    right: 30, // 기본 20px
                },
            })
        }
        //   const ChannelBoot = () => {
        //     const waitForElement = () => {
        //       const launcher = document.querySelector('.channel-talk-btn');

        //       if (!launcher) {
        //         setTimeout(waitForElement, 200);
        //         return;
        //       }

        //       if (!window.ChannelIO) {
        //         setTimeout(waitForElement, 200);
        //         return;
        //       }

        //       // 여기서 boot
        //       window.ChannelIO('boot', {
        //         pluginKey: process.env.VUE_APP_CHANNELTALK_KEY,
        //         mobileMessengerMode: 'iframe',
        //         customLauncherSelector: '.channel-talk-btn',
        //         hideChannelButton: true // ✅ 기본 버튼 숨김

        //         // appearance: {
        //         //     position: 'br', // 기본값: bottom right
        //         //     bottom: 100, // px 단위로 위로 올림 (기본 20)
        //         //     right: 30,  // 기본 20px
        //         // }
        //       });
        //     };

        //     waitForElement();
        //   };

        const ChannelShutdown = () => {
            window.ChannelIO('shutdown')
        }

        // 전역 등록
        Vue.prototype.$ChannelBoot = ChannelBoot
        Vue.prototype.$ChannelShutdown = ChannelShutdown

        // 앱 실행 시 자동 boot
        //   ChannelBoot();
    },
}

// export default (ctx, inject) => {
//     (function() {
//         const w = window;
//         if (w.ChannelIO) {
//             return (window.console.error || window.console.log || function(){})('ChannelIO script included twice.');
//         }
//         const ch = function() {
//             ch.c(arguments);
//         };
//         ch.q = [];
//         ch.c = function(args) {
//             ch.q.push(args);
//         };
//         w.ChannelIO = ch;
//         function l() {
//             if (w.ChannelIOInitialized) {
//                 return;
//             }
//             w.ChannelIOInitialized = true;
//             const s = document.createElement('script');
//             s.type = 'text/javascript';
//             s.async = true;
//             s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
//             s.charset = 'UTF-8';
//             const x = document.getElementsByTagName('script')[0];
//             x.parentNode.insertBefore(s, x);
//         }
//         if (document.readyState === 'complete') {
//             l();
//         } else if (window.attachEvent) {
//             window.attachEvent('onload', l);
//         } else {
//             window.addEventListener('DOMContentLoaded', l, false);
//             window.addEventListener('load', l, false);
//         }
//     })();
//     // ChannelIO('boot', {
//     //     "pluginKey": process.env.VUE_APP_CHANNELTALK_KEY,
//     //     'mobileMessengerMode': 'iframe',

//     // });

//     const ChannelBoot = () => {
//         window.ChannelIO('boot', {
//             "pluginKey": process.env.VUE_APP_CHANNELTALK_KEY,
//             'mobileMessengerMode': 'iframe',
//             }
//         );
//     }
//     const ChannelShutdown = () => {
//         window.ChannelIO('shutdown')
//     }
//     ChannelBoot()
//     inject('ChannelBoot', ChannelBoot)
//     inject('ChannelShutdown', ChannelShutdown)
// }
